import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AUTH_TOKEN_COOKIE, getCookie } from "utils/cookies";

export const hasRkAuthToken = () => Boolean(getCookie(AUTH_TOKEN_COOKIE));

export const RkProtectedRoute = () =>
  hasRkAuthToken() ? <Outlet /> : <Navigate to="/rk" replace />;

export const RkPublicOnlyRoute = () =>
  hasRkAuthToken() ? <Navigate to="/rk/home" replace /> : <Outlet />;
